import React, {useEffect} from "react";
import {Outlet, useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";

const VendorLayout = () => {
    const navigate = useNavigate();
    const {isValid} = useSelector(state => state.vendor);
    const params = useParams();
    const path = `/vendor-dashboard/${params.vendorId}/${params.scopeId}`;

    useEffect(() => {
        isValid === false && navigate(path);
    }, [isValid, navigate, path])

    return (
        <div className="vendor-layout p-5 bg-body-tertiary vh-100">
            <Outlet/>
        </div>
    );
};

export default VendorLayout;